export default __webpack_public_path__ + "static/media/1916.b62a7e24.png";